export default __webpack_public_path__ + "static/media/vouchers--roi.e413146c.png";